// The viewer a control drives, however the page happens to hold it.
//
// Ten live files mount a viewer and they hold it three different ways: a
// getter, a React ref, or a WebGlApp that keeps it on `.viewer`. Every
// viewer control needs the same three-way resolution, so it lives here
// rather than being copied into each - the second copy is where they start
// disagreeing about which shapes are supported.
//
// `probe` is the method that proves this object really is the viewer and
// not the wrapper around it. Different controls care about different
// methods, so each passes its own.
export default function resolveViewer(viewer, probe = "setShading") {
  try {
    const held = typeof viewer === "function" ? viewer() : viewer;
    if (!held) return null;
    if (typeof held[probe] === "function") return held;
    // a React ref, or a WebGlApp that keeps the viewer on `.viewer`
    const inner = held.current || held.viewer;
    if (inner && typeof inner[probe] === "function") return inner;
    if (inner && inner.viewer && typeof inner.viewer[probe] === "function") return inner.viewer;
  } catch (e) { /* a page tearing down */ }
  return null;
}
